import { createContext, useContext, type ReactNode } from "react";
import { useAuth } from "./use-auth";

type AuthValue = ReturnType<typeof useAuth>;

const Ctx = createContext<AuthValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const value = useAuth();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAuthContext(): AuthValue {
  const v = useContext(Ctx);
  if (!v) throw new Error("認証状態の初期化に失敗しました");
  return v;
}
